import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../../components/Navbar";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import Footer from "../../components/Footer";
import ProductShowcase from "../../components/cultivars/Chemicalbromance/ProductShowcase";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";

const Chemicalbromance = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Chemical Bromance Cultivar - BeyondBloom™</title>
        <meta name="description" content="Discover Chemical Bromance, a high-quality cultivar from BeyondBloom™. Experience its powerful effects and premium genetics." />
        <meta name="keywords" content="Chemical Bromance, cannabis, premium cultivar, BeyondBloom, strains, high-quality genetics, Chem De La Chem" />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta property="og:title" content="Chemical Bromance Cultivar - BeyondBloom™" />
        <meta property="og:description" content="Discover Chemical Bromance, a high-quality cultivar from BeyondBloom™. Experience its powerful effects and premium genetics." />
        <meta property="og:image" content="/images/chem-de-la-chem.png" />
        <meta property="og:url" content="https://yourwebsite.com/chemical-bromance" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Chemical Bromance Cultivar - BeyondBloom™" />
        <meta name="twitter:description" content="Discover Chemical Bromance, a high-quality cultivar from BeyondBloom™. Experience its powerful effects and premium genetics." />
        <meta name="twitter:image" content="/images/chem-de-la-chem.png" />
      </Helmet>

      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default Chemicalbromance;
